/**
 * @module app.shared
 */

export type HttpRequestFormat = 'raw' | 'json';

export type HttpRequestCache = 'default' | 'none';

export interface IHttpRequestOptions {
    method: string;
    format: HttpRequestFormat;
    cache: HttpRequestCache;
}

const defaultOptions: Readonly<IHttpRequestOptions> = {
    method: 'GET',
    format: 'json',
    cache: 'default'
}

export function httpRequest(url: string, options: Partial<IHttpRequestOptions>): Promise<any> {
    const opts = { ...defaultOptions, ...options };

    // replace this with a common function used wherever we load JSON files
    return new Promise((resolve, reject) => {

        const xhr = new XMLHttpRequest();
        xhr.open(opts.method, url, true);

        if(opts.cache === 'none') {
            xhr.setRequestHeader('cache-control', 'no-cache, must-revalidate, post-check=0, pre-check=0');
            xhr.setRequestHeader('cache-control', 'max-age=0');
            xhr.setRequestHeader('expires', '0');
            xhr.setRequestHeader('expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
            xhr.setRequestHeader('pragma', 'no-cache');
        }


        xhr.addEventListener('readystatechange', () => {
            if(xhr.readyState === 4 && xhr.status === 200) {
                if(opts.format === 'json') {
                    resolve(JSON.parse(xhr.responseText));
                }
                else {
                    resolve(xhr.responseText);
                }
            }
        });

        xhr.addEventListener('loadend', () => {
            if(xhr.status === 404) {
                reject(`Resource not found: ${url}`);
            }
        });

        xhr.addEventListener('loaderror', () => {
            reject(`Resource could not be found or loaded: ${url}`);
        });

        xhr.send();

    });
}
